import { useCallback, useEffect } from 'react';

/**
 * Window size interface
 */
export interface WindowSize {
  width: number;
  height: number;
}

/**
 * Hook for tracking window size
 */
export function useWindowSize(handler: (size: WindowSize) => void): void {
  const IS_CLIENT = typeof window !== 'undefined';

  // Create the update function
  const handleResize = useCallback(() => {
    if (!IS_CLIENT) return;

    const size = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    handler(size);
  }, [handler, IS_CLIENT]);

  // Set up event listener
  useEffect(() => {
    if (!IS_CLIENT) return;

    // Initial size calculation
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, IS_CLIENT]);
}
